export const FIELDS_TO_CHECK = [
  "company_name",
  "person_first_name",
  "person_last_name",
];

export const FIELDS_TO_PREFILL = [
  "person_first_name",
  "full_name",
  "person_full_name",
  "company_name"
];
